import {
  Component,
  Input,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { selectUser } from 'src/app/core/reducers';

import { AppState } from 'src/app/reducers';
import {
  TriggeredAlertsScope,
  injectTriggeredAlertsQuery,
  toggleTriggeredAlertExpanded,
} from 'src/app/api/queries/alert.queries';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  selector: 'app-dropdown-alerts',
  templateUrl: './dropdown-alerts.component.html',
  styleUrls: ['./dropdown-alerts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropdownAlertsComponent {
  @Input() closeMethod!: () => void;

  private readonly store = inject(Store<AppState>);
  private readonly queryClient = inject(QueryClient);
  public readonly alertService = inject(AlertService);

  private readonly user = this.store.selectSignal(selectUser);

  private readonly scope = computed<TriggeredAlertsScope | null>(() => {
    const user = this.user();

    return user?.id
      ? { userId: user.id, companyId: user.active_company_id }
      : null;
  });

  private readonly alertsQuery = injectTriggeredAlertsQuery(this.scope);

  readonly alerts = computed(() => this.alertsQuery.data() ?? []);
  readonly alertsLoading = this.alertsQuery.isLoading;
  readonly alertCount = computed(() => this.alerts().length);

  toggleExpandAlert(id: string, event: MouseEvent) {
    event.stopPropagation();
    toggleTriggeredAlertExpanded(this.queryClient, id);
  }
}
